import React from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";
import DateRange from "../../../../components/filter/DateRange";
import PetFilter from "../../../../components/filter/PetFilter";
import ServiceFilter from "../../../../components/filter/ServiceFilter";
import SpeciesFilter from "../../../../components/filter/SpeciesFilter";
import UserFilter from "../../../../components/filter/UserFilter";
import Paging from "./Paging";
import { useTranslation } from "react-i18next";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Close } from "@mui/icons-material";
import { Drawer } from "@mui/material";

const filterComponents = [
  {
    component: <ServiceFilter testId={"appointment.pending-filters.service-select"} />,
    label: "Service",
  },
  {
    component: <UserFilter testId={"appointment.pending-filters.user-input"} />,
    label: "User",
  },
  {
    component: <PetFilter testId={"appointment.pending-filters.pet-select"} />,
    label: "Pet",
  },
  {
    component: <SpeciesFilter testId={"appointment.pending-filters.species-select"} />,
    label: "Species",
  },
];

export const pendingFilterValues = {
  user: "user",
  pet: "pet",
  to: "to",
  from: "from",
  page: "page",
  species: "species",
  service: "service",
};

export default function PendingAppointmentsFilter({ pages }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = React.useState(false);

  function handleReset() {
    const newParams = new URLSearchParams(searchParams);
    Object.values(pendingFilterValues).forEach((key) => {
      if (key !== "page") {
        newParams.delete(key);
      }
    });
    setSearchParams(newParams);
    setOpen(false);
  }

  const filterGrid = (
    <>
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={3} alignItems="flex-start">
          {filterComponents.map((filter, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              {filter.component}
            </Grid>
          ))}
        </Grid>
      </Box>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ mt: 2 }}
      >
        <DateRange
          margin={0}
          paramsEnd={pendingFilterValues.to}
          paramsStart={pendingFilterValues.from}
          pageParam={pendingFilterValues.page}
          testId={"appointment.pending-filters.date-range"}
        />
        {isMobile ? null : (
          <Button
            onClick={handleReset}
            color="error"
            sx={{
              width: { xs: "100%", sm: "25%" },
            }}
            variant="outlined"
            data-testid={"appointment.pending-filters.reset-button"}
          >
            {t("Reset")}
          </Button>
        )}
      </Stack>
    </>
  );

 if (isMobile) {
   return (
     <>
       <Button
         color="primary"
         variant="contained"
         sx={{ mb: 2 }}
         startIcon={<FilterAltIcon />}
         onClick={() => setOpen(true)}
       >
         {t("Filter")}
       </Button>
       <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
         <Box sx={{ width: 300, p: 2 }}>
           <Box
             display="flex"
             justifyContent="space-between"
             alignItems="center"
             mb={2}
           >
             {t("Filters")}
             <IconButton color="error" onClick={() => setOpen(false)} title={t("Close")}>
               <Close />
             </IconButton>
           </Box>
           {filterGrid}
           <Button
             onClick={handleReset}
             color="error"
             variant="contained"
             sx={{ mt: 2, width: "100%" }}
           >
             {t("Reset")}
           </Button>
         </Box>
       </Drawer>
     </>
   );
 }

  return (
    <Card
      elevation={1}
      sx={{
        p: 3,
        mb: 3,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
      }}
    >
      <>
        {filterGrid}
        <Paging pages={pages} />
      </>
    </Card>
  );
}
